/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BumpMenu
 */
export interface BumpMenu {
    /**
     * 
     * @type {string}
     * @memberof BumpMenu
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BumpMenu
     */
    shortText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BumpMenu
     */
    name?: string | null;
}

export function BumpMenuFromJSON(json: any): BumpMenu {
    return BumpMenuFromJSONTyped(json, false);
}

export function BumpMenuFromJSONTyped(json: any, ignoreDiscriminator: boolean): BumpMenu {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'shortText': !exists(json, 'shortText') ? undefined : json['shortText'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function BumpMenuToJSON(value?: BumpMenu | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'shortText': value.shortText,
        'name': value.name,
    };
}


